// extracted by mini-css-extract-plugin
export var button = "KathmanduLandingPage-module__button___tDbUB";
export var cancel = "KathmanduLandingPage-module__cancel___o4DQ2";
export var content = "KathmanduLandingPage-module__content___xR_ft";
export var copy = "KathmanduLandingPage-module__copy___bkd_1";
export var desktopDisclaimer = "KathmanduLandingPage-module__desktopDisclaimer___TEDQ1";
export var head = "KathmanduLandingPage-module__head___BS3HE";
export var hero = "KathmanduLandingPage-module__hero___wHZYq";
export var logo = "KathmanduLandingPage-module__logo___COB7G";
export var logoDesktop = "KathmanduLandingPage-module__logoDesktop___Vn_Ju";
export var logoMobile = "KathmanduLandingPage-module__logoMobile___BLVP3";
export var lottie = "KathmanduLandingPage-module__lottie___zbQ6r";
export var mobileDisclaimer = "KathmanduLandingPage-module__mobileDisclaimer___JCqlG";
export var picture = "KathmanduLandingPage-module__picture___IQJbS";
export var subLogo = "KathmanduLandingPage-module__subLogo___A0tAw";
export var subhead = "KathmanduLandingPage-module__subhead____8c2k";
export var title = "KathmanduLandingPage-module__title___yWmwQ";
export var wrapper = "KathmanduLandingPage-module__wrapper___wyLcA";